$(document).ready(function() {
  $.ajax({
    method: 'post',
    url: '/api/lk/get-user-register-status',
    success: r => {
      if (r.STATUS == 'LOAD') {
        $('.header__disc').addClass('header__disc_yellow')
        $('.header__disc-text').html('Ожидайте подтверждение регистрации')
        $('.header__hint').show()
      } else if (r.STATUS == 2) {
        $('.header__disc').addClass('header__disc_red')
        $('.header__disc-text').html('Заявка на регистрацию отклонена')
      }
    },
    error: e => {
      console.log(e)
    }
  })
})